export default __webpack_public_path__ + "static/ti_Monster_Pink-7f6327027f0dabca2b221a97a48dcda4.png";